// extracted by mini-css-extract-plugin
export var standaloneTable = "_dk-0";
export var standaloneTableWithBodyFill = "_dk-1";
export var withExtraHeader = "_dk-2";